import React, { useEffect } from "react";
import {
  connect,
  useDispatch,
  useSelector
} from "react-redux";
import { CardBody } from "reactstrap";
import LinkClient from "../LinkClient";
import LinkIb from "../LinkIb";
import UnLinkIb from "../unLinkIb";
import UnLinkClients from "../unLinkClients";
import ConvertToIb from "../ConvertToIb";
import AddSharedAgreement from "../AddSharedAgreement";
import AddMasterAgreement from "../AddMasterAgreement";
import AgreementDetailsModal from "../AgreementDetailsModal";
import { fetchAgreements } from "store/actions";

const IbQuickActions = (props) => {
  const {
    clientDetails,
    clientId,
    ibAgrementPermissions,
  } = props;
  const dispatch = useDispatch();
  const { agreements } = useSelector((state) => state.ibAgreements);
    
  useEffect(() => {
    clientId && dispatch(fetchAgreements({ customerId: clientId }));
  }, [clientId]);

  return (
    <CardBody className="quick-actions-card">
      <p className="quick-actions-heading">IB</p>
      <div className="btn-container">
        {clientDetails.fx?.isIb && <LinkClient clientId={clientId} />}
        <LinkIb
          clientId={clientId}
          isClient={clientDetails.fx?.isClient}
          isIb={clientDetails.fx?.isIb}
          isLead={clientDetails.isLead}
        />
        {clientDetails.parentId?._id && <UnLinkIb
          link={clientDetails.parentId}
          clientId={clientId}
          isLead={clientDetails.isLead}
        />}
        {clientDetails.fx?.isIb && <UnLinkClients clientId={clientId} />}
        {clientDetails.fx?.isIb && ibAgrementPermissions?.create &&
          <>
            <AddSharedAgreement clientId={clientId} />
            <AddMasterAgreement clientId={clientId} />
          </>}
        {!clientDetails.fx?.isIb && (
          <ConvertToIb
            convertToIbDetails={props?.convertToIb}
            id={props?.clientDetails?._id}
            kyc={props?.clientDetails?.stages?.kycApproved}
            isLead={props.clientDetails.isLead}
            isIb={props.clientDetails.fx?.isIb}
          />
        )}
        {clientDetails?.parentId && (
          <AgreementDetailsModal agreement={clientDetails?.agreement || agreements?.[0]} />
        )}
      </div>
    </CardBody>
  );
};

const mapStateToProps = (state) => ({
  ibAgrementPermissions: state.Profile.ibAgrementPermissions || {},
});

export default connect(mapStateToProps, null)(IbQuickActions);